import React, { Component } from "react";
import { Col, Row, Button, Typography, Divider, Dropdown, Menu, Tooltip } from 'antd'
import JenkinsListing from "views/JenkinsResult/JenkinsListing";
import { BASE_GUTTER } from "constants/Layout";
import ModalUtil from "utils/modalUtil";
import JenkinsFormPopup from "./JenkinsFormPopup";
import _ from 'lodash';
import AuthorisedContainer from "components/AuthorisedContainer";
import { PermissionSetMap } from "constants/RBACConstants";
import { AdditionalSettingIcon } from "components/Icons";
import { withFeatureFlags } from "contexts/FeatureFlagContext";

const toolNameMap = {
    Azure_Pipeline: "Azure pipeline",
    Jenkins: "Jenkins",
    Circle_CI: "Circle CI",
    Drone: "Drone",
    Team_City: "team city"
} 
export default withFeatureFlags(class JenkinsDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            config: {}
        }
        this.toolName = props.id;
        this.toolType = toolNameMap[this.toolName];
        _.bindAll(this, "showScriptPopup")
    }

    showScriptPopup(selectedMenuKeyForJenkins) {
        ModalUtil.show({
            content: <JenkinsFormPopup id={this.toolName} selectedMenuKeyForJenkins={selectedMenuKeyForJenkins} />,
        });
    }

    getMenu() {
        return (
            <Menu onClick={({ key }) => this.showScriptPopup(key)}>
                <Menu.Item key="jenkinsPlugin">Jenkins Plugin</Menu.Item>
                <Menu.Item key="jenkinsScript">Script</Menu.Item>
            </Menu>
        );
    }

    render() {
        return <Row gutter={BASE_GUTTER}>      
                <Col className="d-flex justify-content-flex-end align-items-center" span={24}>
                    {this.toolType && <Typography.Link href={getToolLink(this.toolType)} rel="noopener noreferrer" target="_blank" className='m-r-sm'>How to setup {this.toolName.replace('_', ' ')}?</Typography.Link>}
                    <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS}>
                    {this.toolType === "Jenkins" ? (
                            <Dropdown overlay={this.getMenu()} trigger={["click"]}>
                                <Button type="primary">Connect to Jenkins</Button>
                            </Dropdown>
                        ) : (
                            <Button type="primary" onClick={this.showScriptPopup}>Generate Script</Button>
                        )}
                    </AuthorisedContainer>
                    <Divider type="vertical" />
                    <Tooltip title="Edit Release Gate" placement="topRight">
                        <Typography.Link href="#/globalsettings?activeStep=step15">
                            <AdditionalSettingIcon className="clickable"/>
                        </Typography.Link>
                    </Tooltip>
                    
                </Col>
                <Col span={24}>
                    <JenkinsListing id={this.toolName} />
                </Col>
        </Row>
    }
}
)
function getToolLink(name) { 
    switch (name) {
        case toolNameMap.Jenkins:
            return  `/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19601541733395-Jenkins`;
        case toolNameMap.Circle_CI:
            return `/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19600918376595-Circle-CI`;
        case toolNameMap.Drone:
            return `/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19601131768467-Drone`;
        case toolNameMap.Team_City:
            return `/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19600800162067-Team-City`;
        case toolNameMap.Azure_Pipeline:
            return `/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19601465879315-Azure-Pipeline`;
        default:
            return "";
    }
}